export interface Callbacks<T> {
    onError?: (message: string) => void,
    onSuccess?: (response?:T) => void,
    onLoading?:(loading:boolean)=>void,
    onAbort?:(controller:AbortController)=>void,
}
const useCallBack = <T>(callbacks:Callbacks<T> | undefined)=>{
    const onError= (error: Error) => {
        if (callbacks && callbacks.onError) {
            const message = error.message
            callbacks.onError!(message)
        }
    }

    const onSuccess= (response: T) => {
        if (callbacks && callbacks.onSuccess) {
            callbacks.onSuccess(response)
        }
    }

    const onLoading = (loading:boolean)=>{
        if(callbacks && callbacks.onLoading){
            callbacks.onLoading(loading)
        }
    }

    const onAbort = (controller:AbortController)=>{
        if(callbacks && callbacks.onAbort){
            callbacks.onAbort(controller)
        }
    }

    return{onError, onSuccess, onLoading, onAbort}
}

export default useCallBack
